import api from "./client";
export async function uploadSingle(file) {
    const form = new FormData();
    form.append("file", file);
    const res = await api.post("/admin/uploads", form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
}
export async function uploadMultiple(files) {
    const form = new FormData();
    files.forEach((f) => form.append("files", f));
    const res = await api.post("/admin/uploads/multi", form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
}
export async function deleteUpload(filename) {
    await api.delete(`/admin/uploads/${filename}`);
}
